import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountDto, LicenceDto } from '../../dtos/dtos';
import { AccountService } from '../../services/account.service';
import { LicenceService } from '../../services/licence.service';

@Component({
  selector: 'je-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccountComponent implements OnInit {
  public account: AccountDto = new AccountDto();
  public licences: LicenceDto[] = [];
  private accountPerma: string;
  years: number[] = [];
  yearly = {};
  unpaidLicences: { [year: number]: LicenceDto } = {};

  constructor(
    private accountService: AccountService,
    private licenceService: LicenceService,
    private route: ActivatedRoute,
  ) {
    this.accountPerma = this.route.snapshot.params['perma'];
  }

  ngOnInit() {
    this.loadAccount();
    this.loadLicences();
    this.loadUnpaidLicenceCount();
  }

  private loadAccount() {
    this.accountService
      .get(this.accountPerma)
      .toPromise()
      .then((resp) => {
        this.account = resp;
      });
  }

  private loadLicences() {
    this.licenceService
      .getAllByAccountPerma(this.accountPerma)
      .toPromise()
      .then((resp) => {
        this.licences = resp;

        this.years = [...new Set(this.licences.map((el) => el.year))].sort(
          (a, b) => b - a,
        );

        this.years.forEach((year) => {
          this.yearly[year] = this.licences
            .filter((el) => el.year == year)
            .sort(
              (a, b) =>
                a.type.id.localeCompare(b.type.id) ||
                a.description?.localeCompare(b.description) ||
                a.permaId.localeCompare(b.permaId),
            );
        });
      });
  }

  private loadUnpaidLicenceCount() {
    this.licenceService
      .getUnpaidLicenceCount(this.accountPerma)
      .toPromise()
      .then((resp) => {
        this.unpaidLicences = resp;
      });
  }

  showWarningBadge(year: number) {
    return this.unpaidLicences[year] != null;
  }

  continue(permaId: string) {
    this.licenceService
      .continueSubscription(permaId, this.accountPerma)
      .toPromise()
      .then(() => {
        this.loadLicences();
        this.loadUnpaidLicenceCount();
      });
  }

  stop(permaId: string) {
    this.licenceService
      .stopSubscription(permaId, this.accountPerma)
      .toPromise()
      .then(() => {
        this.loadLicences();
        this.loadUnpaidLicenceCount();
      });
  }
}
